/* Copyright (c) 2022 chilled.dev */

import { CircularProgress, Stack } from '@mui/material';
import { FC, useEffect, useState } from 'react';

export interface LazyLoaderProps {
  delay?: number;
}

const LazyLoader: FC<LazyLoaderProps> = ({ delay = 600, ...props }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(true);
    }, delay);
    return () => {
      clearTimeout(timeout);
    };
  }, [delay]);

  return show ? <Loader {...props} /> : null;
};

const Loader = () => (
  <Stack
    style={{
      position: 'fixed',
      height: '100vh',
      width: '100vw',
      top: 0,
      left: 0,
      backdropFilter: 'blur(4px)',
    }}
    alignItems='center'
    justifyContent='center'
  >
    <CircularProgress />
  </Stack>
);

export default LazyLoader;
